import React, { useEffect, useState } from "react";
import CreateInputHolder from "../create/CreateInputHolder";
import FillInComplete from "../create/FillInComplete";
import { makeBoxType } from "../create/newObjects";
import { storage } from "../firebase/fireInit";
import {
  addPropertyToGeneralObject,
  getCreationInput,
} from "../misc/helperfuncs";
import boxTypeInputs from "./boxTypeInputs";
import { ref } from "firebase/storage";
import { getDownloadURL } from "firebase/storage";
import {
  checkGeneralRelatedTypes,
  checkIfPlayerBoxTypeDocExists,
  saveBoxType,
} from "../firebase/fireFuncs";
import {
  addRemoveBoxType,
  storeBoxTypeInStorage,
} from "../firebase/playerFuncs";
import MainStore from "../stores/MainStore";
import { toast } from "react-toastify";
import BackButton from "../misc/elements/BackButton";
import collectionStore from "./../stores/collectionStore";

const CreateNewBoxType = ({
  firstTime,
  onBack,
  action,
  fromModal = false,
  outsideBoxType,
  onSaved,
}) => {
  const { player } = MainStore();
  const [inputs, setInputs] = useState([]);
  const [clicks, setClicks] = useState(null);
  const [filledOut, setFilledOut] = useState(true);
  const [saving, setSaving] = useState(false);
  const [boxType, setBoxType] = useState(null);
  const { setGeneralObjects } = collectionStore();

  useEffect(() => {
    if (!outsideBoxType) setBoxType(makeBoxType());
    else setBoxType(outsideBoxType);
  }, []);

  function afterDocCheck() {
    console.log("afterDocCheck | firstTime -  ", firstTime);
    if (firstTime) {
      saveBoxType(boxType, (found) => {
        addRemoveBoxType(player, boxType, true);
        if (found) toast(`${boxType.names.plural} already existed`);
        setBoxType(null);
        setSaving(false);
        addPropertyToGeneralObject(boxType.names.plural, setGeneralObjects);
        if (onSaved) onSaved();
      });
    } else {
      addRemoveBoxType(player, boxType, true);
      checkGeneralRelatedTypes(boxType.related, boxType.names.plural);
      if (onBack) onBack();
      toast(`updating ${boxType.names.plural} `);
    }
    storeBoxTypeInStorage(boxType);
  }

  useEffect(() => {
    console.log(" saving - ", saving);
    if (saving) {
      checkIfPlayerBoxTypeDocExists(
        player.uid,
        boxType.names.plural,
        afterDocCheck
      );
    }
  }, [saving]);

  function checkIfFilled() {
    var filled = true;
    const inputFields4 = [
      boxType.names.singular,
      boxType.names.plural,
      boxType.colors.primary,
      boxType.colors.secondary,
      boxType.colors.text,
      boxType.ratings.general.first.general.name,
      boxType.ratings.general.first.general.hint,
      boxType.ratings.general.first.general.icon,
      boxType.ratings.general.first.personal.name,
      boxType.ratings.general.first.personal.hint,
      boxType.ratings.general.second.general.name,
      boxType.ratings.general.second.general.hint,
      boxType.ratings.general.second.general.icon,
      boxType.ratings.general.second.personal.name,
      boxType.ratings.general.second.personal.hint,
      boxType.ratings.active.first.name,
      boxType.ratings.active.first.hint,
      boxType.ratings.active.first.icon,
      boxType.ratings.active.second.name,
      boxType.ratings.active.second.hint,
      boxType.ratings.active.second.icon,
      boxType.ratings.completed.first.name,
      boxType.ratings.completed.first.hint,
      boxType.ratings.completed.first.icon,
      boxType.descriptions.shortDescription,
      boxType.descriptions.longDescription,
      boxType.descriptions.image,
      boxType.descriptions.categories,
      boxType.descriptions.keywords,
      boxType.descriptions.things,
      boxType.completed,
      boxType.icon,
    ];
    for (let i = 0; i < inputFields4.length; i++) {
      const field = inputFields4[i];
      if (field != null) {
        if (field.length < 4) {
          filled = false;
          break;
        }
      }
    }

    setFilledOut(filled);
  }

  useEffect(() => {
    if (boxType) {
    }
  }, [boxType]);

  const [refs, setRefs] = useState([]);
  const [refIndex, setRefIndex] = useState(1);

  useEffect(() => {
    if (refs.length > 0) {
      refs[0].current.focus();
    }
  }, [refs]);

  function onEnter(e) {
    if (e.key == "Enter") {
      refs[refIndex].current.focus();
      setRefIndex((state) => (state + 1) % refs.length);
    }
  }

  function addInputRef(inputRef) {
    setRefs((state) => {
      if (!state.includes(inputRef)) return [...state, inputRef];
      else return state;
    });
  }

  function onInputChange(value, field) {
    const isArray = Array.isArray(field);
    if (isArray) {
      if (field.length == 2) {
        setBoxType({
          ...boxType,
          [field[0]]: {
            ...boxType[field[0]],
            [field[1]]: value.toLowerCase(),
          },
        });
      }
    } else {
      setBoxType({
        ...boxType,
        [field]: value.toLowerCase(),
      });
    }
  }

  function onColorPicked(colors) {
    setBoxType({ ...boxType, colors });
  }

  function onRatingInputChange(ratingObject, personalObject, fields) {
    const newRatings = { ...boxType.ratings };
    if (fields.length == 3) {
      newRatings[fields[0]][fields[1]] = {
        general: ratingObject,
        personal: personalObject,
      };
    }
    if (fields.length == 2) {
      newRatings[fields[0]][fields[1]] = ratingObject;
    }
    setBoxType({ ...boxType, ratings: newRatings });
  }

  function onEnableTime(bol) {
    setBoxType({ ...boxType, time: bol });
  }
  function onTimeDescription(description) {
    setBoxType({ ...boxType, time: description });
  }

  function onIconPicked(icon) {
    getDownloadURL(ref(storage, icon)).then((url) => {
      setBoxType({ ...boxType, icon: url });
    });
  }

  function togglePoints(bol) {
    setBoxType({ ...boxType, points: bol });
  }

  function clickRelatedType(type) {
    const newDescriptions = { ...boxType.related.descriptions };
    const relatedTypes = [...boxType.related.types];
    if (relatedTypes.includes(type)) {
      relatedTypes.splice(relatedTypes.indexOf(type), 1);
      delete newDescriptions[type];
    } else {
      if (relatedTypes.length < 4) {
        newDescriptions[type] = "";
        relatedTypes.push(type);
      } else toast("You can only have 4 related types");
    }
    setBoxType({
      ...boxType,
      related: {
        ...boxType.related,
        types: relatedTypes,
        descriptions: newDescriptions,
      },
    });
  }

  function onRelatedDescription(type, description) {
    const newDescriptions = { ...boxType.related.descriptions };
    newDescriptions[type] = description;
    setBoxType({
      ...boxType,
      related: { ...boxType.related, descriptions: newDescriptions },
    });
  }

  useEffect(() => {
    const obj = {};
    obj.onEnter = onEnter;
    obj.onInputChange = onInputChange;
    obj.onColorPicked = onColorPicked;
    obj.onRatingInputChange = onRatingInputChange;
    obj.onEnableTime = onEnableTime;
    obj.onTimeDescription = onTimeDescription;
    obj.onImageChanged = onIconPicked;
    obj.togglePoints = togglePoints;
    obj.clickRelatedType = clickRelatedType;
    obj.onRelatedDescription = onRelatedDescription;
    setClicks(obj);
  }, [boxType]);

  useEffect(() => {
    if (boxType) {
      const inputs = boxTypeInputs(boxType);
      checkIfFilled();
      setInputs(inputs);
    }
  }, [boxType]);
  return (
    <div
      className="divColumn"
      style={{
        width: "1200px",
        backgroundColor: "#9f9f9f",
        marginTop: "5px",
        paddingBottom: "15px",
        position: "relative",
      }}
    >
      {onBack && (
        <div
          className="divRow"
          style={{ position: "absolute", left: 0, marginLeft: "5px", top: 2 }}
        >
          <BackButton
            onClick={() => {
              if (onBack) onBack();
            }}
          />
        </div>
      )}
      <div
        onClick={() => {
          console.log(
            "boxType - ",
            boxType,
            " firstTime - ",
            firstTime,
            " | saving - ",
            saving
          );
        }}
        className="textBoldWhite"
        style={{ marginTop: "10px", fontSize: "25px" }}
      >
        Create A New Box Type
      </div>
      <div
        className="divColumn"
        style={{
          width: "100%",
          overflow: "auto",
          minHeight: "500px",
          maxHeight: "500px",
        }}
      >
        {inputs.map((input, index) => {
          return (
            <CreateInputHolder
              fromModal={fromModal}
              action={action}
              key={index}
              addInputRef={addInputRef}
              clicks={clicks}
              type={input.type}
              name={input.name}
              field={input.field}
              hint={input.hint}
              extras={input.extras}
              mandatory={input.mandatory}
              payload={input.payload}
              width={"60%"}
            />
          );
        })}
        {filledOut && (
          <FillInComplete
            type={"Box Type"}
            onClick={() => setSaving(true)}
            action={"Save"}
          />
        )}
      </div>
    </div>
  );
};

export default CreateNewBoxType;
